<template>
  <div class="entry-main-wrapper">
    <DataLoader :is_on="fetching" />
    <div class="entry-wrapper">
      <div class="entry-header">
        <div class="entry-header-left">
          <div class="entry-icon">
            <img src="@/assets/img/novi_predmet.svg" />
          </div>
          <div class="entry-title">{{ title_edit_new }}</div>
        </div>
        <div class="entry-header-right">
          <a @click="goBack()" class="entry-exit"
            ><img src="@/assets/img/entry_form_close.svg"
          /></a>
        </div>
      </div>
      <!-- end new case header -->
      <div class="main-entry-form-wrapper">
        <!-- *** BROJ PREDMETA **** -->
        <form-input
          :invalid="invalid_elements.broj_predmeta"
          :label="$t('forms.project.br_proj_lbl')"
          id="broj-predmeta"
          ref="brojPredmeta"
          required="required"
          :base="unos_projekta.broj_projekta"
          :is_edit="is_edit"
        ></form-input>
        <!-- *** ČLANOVI TIMA **** -->
        <div class="clanovi-tima-wrapper">
          <div class="form-autocomplete-add-wrapper">
            <form-autocomplete
              :invalid="invalid_elements.clan_tima"
              :label="$t('forms.project.team_members_lbl')"
              type="Član_tima"
              id="clan-tima"
              ref="clanTima"
              :placeholder="$t('forms.project.team_members_plh')"
              :items="tim"
              :statusi="statusi.leg_tim"
              :st_ID="'2'"
              :start="unos_projekta.vezane_osobe.leg_tim.results_final"
            ></form-autocomplete>
          </div>
          <div class="button-assign-wrapper">
            <div class="button-default button-create" @click="assignToMe">{{ $t('forms.project.assign_to_me') }}</div>
          </div>
        </div>
        <div class="form-autocomplete-add-wrapper">
          <form-autocomplete
            :invalid="invalid_elements.stranka"
            type="Stranka"
            :label="$t('forms.project.stranka_lbl')"
            id="stranka_project"
            ref="stranka"
            :start="unos_projekta.vezane_osobe.connected.results_final"
            :placeholder="$t('forms.project.stranka_plh')"
            :items="all_fiz_prav"
            :statusi="statusi.stranka"
          ></form-autocomplete>
          <button-person-quick
            type="Stranka"
            ostalo=true
            :statusi="statusi.stranka"
            ref="quickStranka"
            :postojece_fiz_prav="all_fiz_prav_copy"
            @addToAutocomplete="addToAutocomplete"
          ></button-person-quick>
        </div>
        <!-- *** DIVIDER **** -->
        <div class="form-divider"></div>
        <!-- *** IME PREDMETA **** -->
        <form-input
          :invalid="invalid_elements.ime_predmeta"
          :label="$t('forms.project.proj_name_lbl')"
          id="ime-predmeta"
          ref="nazivProjekta"
          required="required"
          :base="unos_projekta.name"
          :is_edit="is_edit"
        ></form-input>
        <!-- *** OPIS PREDMETA **** -->
        <form-textarea
          :label="$t('forms.project.opis_lbl')"
          id="opis-predmeta"
          ref="opisProjekta"
          :base="unos_projekta.opis_projekta"
        ></form-textarea>
        <div class="form-input-wrapper">
          <label class="form-label" for="datum">
            <span>{{$t('forms.project.date_created')}}</span>
          </label>
          <input
            :class="['form-input', 'date-input']"
            type="date"
            id="datum"
            ref="datumKreiranja"
            name="datum-pocekta"
            v-model="unos_projekta.datum_kreiranja"
          />
        </div>
        <div v-if="finished_project" class="form-input-wrapper">
          <label class="form-label" for="archived">
            <span>{{$t('forms.project.date_finished')}}</span>
          </label>
          <input
            :class="['form-input', 'date-input']"
            type="date"
            id="archived"
            ref="datumArhiviranja"
            name="datum-pocekta"
            v-model="unos_projekta.datum_arhiviranja"
          />
        </div>
        <!-- <form-drop-down
          label="Valuta"
          id="valuta"
          ref="valuta"
          :dropImport="postupak"
          :base="unos_projekta.vrsta_postupka"
        ></form-drop-down> -->
        <InvalidElementsList v-if="errors.length != 0" :error_list="errors"/>
        <!-- *** KREIRAJ BUTTON **** -->
        <div :class="{'fixed-to-bottom single':is_edit}">
            <div class="button-create-wrapper">
              <div :class="{'disabled':is_waiting_on_insert}" class="button-default button-create" @click="!is_waiting_on_insert ? sequence_start() : ''">
                {{ create_edit_button }}
              </div>
            </div>
        </div>
        <div v-if="is_edit" class="button-arhiviraj-wrapper">
          <div :class="['button-arhiviraj',finished_project ? 'green':'danger']" @click="finish_popup=true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 18" fill="none">
              <path d="M3.61461 3.63236C4.92813 2.31432 6.74326 1.5 8.75 1.5C12.7541 1.5 16 4.74594 16 8.75C16 12.7541 12.7541 16 8.75 16C4.74594 16 1.5 12.7541 1.5 8.75C1.5 8.33579 1.16421 8 0.75 8C0.335786 8 0 8.33579 0 8.75C0 13.5825 3.91751 17.5 8.75 17.5C13.5825 17.5 17.5 13.5825 17.5 8.75C17.5 3.91751 13.5825 0 8.75 0C6.32851 0 4.13558 0.984622 2.55213 2.57352C2.52668 2.59906 2.50345 2.62597 2.48245 2.65401L1.22488 1.39645C1.08769 1.25926 0.883533 1.21382 0.701112 1.27986C0.518691 1.34591 0.390942 1.51152 0.373378 1.70473L0.0198239 5.59382C0.00638932 5.7416 0.0592897 5.88771 0.164217 5.99264C0.269145 6.09757 0.415258 6.15047 0.563038 6.13703L4.45213 5.78348C4.64534 5.76591 4.81095 5.63817 4.87699 5.45575C4.94304 5.27332 4.8976 5.06916 4.76041 4.93198L3.5323 3.70386C3.56101 3.68235 3.58854 3.65852 3.61461 3.63236Z" fill="#FD4087"/>
              <path d="M9.5 3.75C9.5 3.33579 9.16421 3 8.75 3C8.33579 3 8 3.33579 8 3.75V8.75C8 9.00859 8.13321 9.24895 8.3525 9.386L11.3525 11.261C11.7038 11.4805 12.1665 11.3738 12.386 11.0225C12.6055 10.6712 12.4988 10.2085 12.1475 9.989L9.5 8.33431V3.75Z" fill="#FD4087"/>
            </svg>
            <span>{{finish_button_text}}</span>
          </div>
        </div>
      </div>
      <v-dialog v-model="finish_popup" width="564px">
        <v-card color="universal-vcard">
          <div :class="['universal-vdialog-title', 'archive-title']">
            {{ popup_text }}
          </div>
          <v-menu v-if="!finished_project" ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :label="$t('forms.project.odaberi_datum')" v-model="dateText" readonly append-icon="mdi-calendar" v-bind="attrs"
                @click="menu1 = !menu1" v-on="on" class="case-date-picker archive-date-picker"></v-text-field>
            </template>
            <v-date-picker locale="hr" :first-day-of-week="1" v-model="unos_projekta.datum_arhiviranja" no-title></v-date-picker>
          </v-menu>
          <div class="vdialog-buttons-wrapper wrapper-three-buttons">
            <div class="universal-vdialog-button vbutton-secondary" @click="finish_popup = false;"> {{ $t("repetitive.cancel") }} </div>
            <div class="universal-vdialog-button vbutton-primary" @click="closeProject()"> {{ popup_button_text }} </div>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="warning_unsaved" width="564px">
        <v-card color="universal-vcard">
            <div class="universal-vdialog-title">
                {{ $t('forms.unsaved_changes') }}
            </div>
            <div class="vdialog-buttons-wrapper">
            <div class="universal-vdialog-button vbutton-secondary" @click="warning_unsaved = false;"> {{ $t("repetitive.cancel") }} </div>
            <div class="universal-vdialog-button vbutton-primary" @click="continueGoBack()"> {{ $t("repetitive.discard") }} </div>
            </div>
        </v-card>
      </v-dialog>
    </div>
    <!-- end new case wrapper -->
  </div>
  <!-- end new case main wrapper -->
</template>


<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import buttonPersonQuick from "@/components/formElements/buttonPersonQuick.vue";
import formCurrencyInput from "@/components/formElements/formCurrencyInput.vue"
import InvalidElementsList from "@/components/generalComponents/InvalidElementsList.vue";
import osobe from "@/apiCallers/promise_handler_db/osobe_pr";
import projects from "@/apiCallers/promise_handler_db/projects";

import financial from "@/apiCallers/promise_handler_db/financial";
import auth from "@/services/auth";
import DataLoader from '@/components/generalComponents/DataLoader'
import { clearProjectData } from "@/router/project/handler"

import moment from 'moment';
import $ from "jquery";
import gsap from "gsap";

export default {
  data() {
    return {
      //
      title_edit_new: this.$t("forms.project.title_new"),
      is_edit: false,
      route_query: undefined,
      create_edit_button: this.$t("forms.project.btn_new"),
      //
      is_waiting_on_insert:false,
      accessToken: "",
      stranke: [],
      all_fiz_prav: [],
      all_fiz_prav_copy:[],
      all_institucije: [],
      prijedlog_br_predmet: "",
      popis_broja_projekta: [],
      protustranke: [],
      tim: [],
      faze: [],
      statusi: {
        stranka: [],
        protustranka: [],
        leg_tim: [],
        leg_body:[],
      },
      legal_bodies:[],
      postupak: [],
      valute: [],
      predmet_all: null,
      unos_projekta: {
        broj_projekta: "",
        name: "",
        opis_projekta: null,
        vezane_osobe: {
          leg_tim: [],
          connected: [],
          quickStranke: [],
        },
        datum_kreiranja:'',
        datum_arhiviranja:'',
      },
      errors:[],
      invalid_elements:{
        broj_predmeta:false,
        stranka:false,
        protustranka:false,
        ime_predmeta:false,
        clan_tima:false,
        VPS:false,
      },
      fetching:true,
      finish_popup:false,
      finish_button_text:this.$t("forms.project.finish_button_text"),
      finished_project:false,
      popup_button_text:this.$t("forms.project.popup_button_text"),
      popup_text:this.$t("forms.project.popup_text"),
      menu1:false,
      temp_archive_date:'',
      warning_unsaved:false,
    };
  },
  watch:{
    finish_popup:function(){
      this.temp_archive_date = this.unos_projekta.datum_arhiviranja;
      if (this.finish_popup && this.unos_projekta.datum_arhiviranja == "") {
        this.unos_projekta.datum_arhiviranja = moment(Date.now()).format("yyyy-MM-DD");
      }
      else{
        this.unos_projekta.datum_arhiviranja = this.temp_archive_date;
      }
    },
  },
  methods: {
    /**
     * Warns user if there are unsaved changes
     * or continues rerouting to previous view
     */
     goBack() {
      if (this.is_edit) {
        this.warning_unsaved = true;
      }
      else{
        this.continueGoBack();
      }
    },
    continueGoBack() {
      this.$router.go(-1);
    },
    async sequence_start() {
      this.validate()
    },
    async closeProject(){
      this.fetching = true;
      await clearProjectData();
      if (this.finished_project) {
        await projects.openProject(this.route_query).then((resp)=>{
          this.fetching = false;
          this.finish_popup = false,
          this.$router.push('/projects/'+this.route_query);
        })
      }
      else{
        await projects.closeProject(this.route_query, this.unos_projekta.datum_arhiviranja).then((resp)=>{
          this.fetching = false;
          this.finish_popup = false,
          this.$router.push('/finished-projects/'+this.route_query);
        })
      }
    },
   async validate(){
      this.clearElements();
      // console.log(this.popis_broja_projekta);
      //check ako postoji predmet u bazi i je li prazan
      if (this.unos_projekta.broj_projekta.value == "") {
        this.errors.push('Potrebno je unijeti broj projekta')
        this.invalid_elements.broj_predmeta = true;
      }
      //check ime predmeta
      if (this.unos_projekta.name.value == "") {
        this.errors.push('Ime projekta treba biti definirano')
        this.invalid_elements.ime_predmeta = true; 
      }

      //check clan tima
      let clan_check = this.unos_projekta.vezane_osobe.leg_tim.results_final;
      let nositelj_found = false;
      let clan_bez_statusa_found = false;
      for (let i = 0; i < clan_check.length; i++) {
        if(clan_check[i].status_ID == 1){
          nositelj_found = true;
        }
        if (clan_check[i].status_ID == 0) {
          clan_bez_statusa_found = true;
        }
      }
      if (!nositelj_found) {
        this.errors.push('Potrebno je definirati barem jednog člana tima kao voditelja');
        this.invalid_elements.clan_tima = true;
      }
      if (clan_bez_statusa_found) {
        this.errors.push('Svi članovi tima moraju imati definirane statuse');
        this.invalid_elements.clan_tima = true;
      }
    
      // console.log(this.unos_projekta);
      //ako nema gresaka kreiraj/update-aj predmet
      //odkomentirati prije unošenja u bazu
      if (this.errors.length == 0) {
        this.fetching=true;
        await clearProjectData();
        this.is_waiting_on_insert = true;
        // console.log(this.unos_projekta)
        if (this.is_edit) {
          console.log("Editing mode")
          this.accessToken = this.$store.state.aToken 
          projects.updateProject(this.unos_projekta, this.accessToken,this.route_query,this.$store.state.logged_in_user.uid).then(async (resp)=>{
            this.continueGoBack();
          }).catch((e)=>{
            this.is_waiting_on_insert = false;
          });    
        }else{
          this.kreirajProjekt();
        }
        // console.log(this.errors);
      }

    },
    clearElements(){
      this.errors = [];
      this.invalid_elements={
        broj_predmeta:false,
        stranka:false,
        protustranka:false,
        ime_predmeta:false,
        clan_tima:false,
        VPS:false,
      }
    },
    async kreirajProjekt() {
      this.accessToken = this.$store.state.aToken 
      console.log(this.unos_projekta);
      projects
        .addProject(this.unos_projekta, this.accessToken,this.$store.state.logged_in_user.uid)
        .then(async (resp) => {
              this.$router.push(resp.data.case_url);
              this.fetching=false;
        }).catch((err)=>{
            this.fetching=false;
        });
    },
    addToAutocomplete(osoba, temp_osoba_status, tip){
      let temp_obj = {
        name: osoba.value,
        status_ID: temp_osoba_status,
        UID: osoba.link,
        is_fiz: osoba.is_fiz,
        connection_status: osoba.connection_status,
      };
      switch (tip) {
        case 'Stranka':
          if (!this.unos_projekta.vezane_osobe.connected.results_final.find(os=>os.UID == temp_obj.UID)) {
            // if (temp_obj.connection_status == 1) {
            //     this.postojeci_dialog_text = "Osoba "+temp_obj.name+' je već protustranka na nekom predmetu! Jeste li sigurni da ju želite dodati kao stranku na ovaj predmet?'
            //     this.temp_osoba = temp_obj;
            //     this.postojeca_stranka_protustranka = true;
            // }
            // else{
              this.all_fiz_prav = this.all_fiz_prav.filter((fiz)=>fiz.link != temp_obj.UID);
              this.unos_projekta.vezane_osobe.connected.results_final.push(temp_obj);
              if (this.$store.state.ime_predmeta.ime_stranke == "" && !this.is_edit) {
                  this.$store.state.ime_predmeta.ime_stranke = osoba.value;
              }
            // }
          }
          break;
        default:
          break;
      }
    },
    assignToMe(){
      let found_nositelj = this.$refs.clanTima.$data.results_final.some((el)=>el.status_ID == 1)
      if (!this.$refs.clanTima.$data.results_final.find(el=>el.UID == this.$store.state.logged_in_user.uid)) {
        this.$refs.clanTima.$data.results_final.push({
          'UID':this.$store.state.logged_in_user.uid,
          'is_fiz':true,
          'name':this.$store.state.logged_in_user.ime + ' '+this.$store.state.logged_in_user.prezime,
          'status_ID': !found_nositelj ? 1 : 2
        });
        this.$refs.clanTima.unableNositelj();
        this.tim = this.tim.filter((fiz)=>fiz.link != this.$store.state.logged_in_user.uid);
      }
    },
    async connectExitstingData() {

      projects.getSingle(this.$route.params.uid,this.$store.state.logged_in_user.uid).then((resp)=>{
        let proj_data = resp.data
        console.log(proj_data)
        if (proj_data.is_archived) {
          this.finished_project = proj_data.is_archived;
          this.finish_button_text = this.$t("forms.project.finish_button_text2");
          this.popup_button_text = this.$t("forms.project.popup_button_text2");
          this.popup_text = this.$t("forms.project.popup_text2")
        }
        this.$refs.brojPredmeta.$data.value = proj_data.broj_projekta;
        this.$refs.nazivProjekta.$data.value = proj_data.name;
        this.$refs.opisProjekta.$data.value = proj_data.opis_projekta;
        
        this.unos_projekta.datum_kreiranja = proj_data.datum_pocetka != "" ? moment(proj_data.datum_pocetka).format("yyyy-MM-DD") : "";
        this.unos_projekta.datum_arhiviranja = proj_data.datum_arhiviranja != "" && proj_data.datum_arhiviranja != null ? moment(proj_data.datum_arhiviranja).format("yyyy-MM-DD") : "";
       
  	    proj_data.connect_project_odvjetnik.forEach((el)=>{
          let temp_obj = {
            "UID":el.odvjetnik.uid,
            "is_fiz":true,
            "name":el.odvjetnik.ime+' '+el.odvjetnik.prezime,
            "status_ID":el.project_odvjetnik_status.id_status,
          };
          this.tim = this.tim.filter((fiz)=>fiz.link != temp_obj.UID);
          this.unos_projekta.vezane_osobe.leg_tim.results_final.push(temp_obj);
          this.$refs.clanTima.unableNositelj();
        })
  	    proj_data.connect_project_legal.forEach((el)=>{
          let temp_obj = {
            "UID":el.pravna_osoba.uid,
            "is_fiz":false,
            "name":el.pravna_osoba.ime,
            "status_ID":el.oznake_status.id_status,
            "connection_status":2
            //vidjeti kaj s connection_status
          };
          this.all_fiz_prav = this.all_fiz_prav.filter((fiz)=>fiz.link != temp_obj.UID);
          this.unos_projekta.vezane_osobe.connected.results_final.push(temp_obj);
        })
  	    proj_data.connect_project_private.forEach((el)=>{
          let temp_obj = {
            "UID":el.fizicka_osoba.uid,
            "is_fiz":true,
            "name":el.fizicka_osoba.ime+' '+el.fizicka_osoba.prezime,
            "status_ID":el.oznake_status.id_status,
            "connection_status":2
            //vidjeti kaj s connection_status
          };
          this.all_fiz_prav = this.all_fiz_prav.filter((fiz)=>fiz.link != temp_obj.UID);
          this.unos_projekta.vezane_osobe.connected.results_final.push(temp_obj);
        })
        this.fetching = false;

      })
    },
  },
  async created() {
    this.fetching=true,
    this.accessToken = this.$store.state.aToken 

    await financial.getAllCurrency().then((resp)=>{
      // console.log(resp)
    })

    await osobe.getAllProjectStatuses().then((resp) => {
      console.log(resp.data.leg_tim_status)
      this.statusi.stranka = resp.data.stranka_protu_statusi;
      this.statusi.protustranka = resp.data.stranka_protu_statusi;
      this.statusi.leg_tim = resp.data.leg_tim_status;
      // console.log(this.statusi.leg_tim);
    });
    await projects.getAllBrojevi().then((resp) => {
      this.unos_projekta.broj_projekta.value = resp.data.predlozak_broj_projekta;
      for (let i = 0; i < resp.data.popis_broja_projekta.length; i++) {
        this.popis_broja_projekta.push(resp.data.popis_broja_projekta[i].broj_projekta);
      }
    });


    await osobe.getAllFizLeg().then((resp) => {
      this.all_fiz_prav = resp.data.all_osobe;
      this.all_fiz_prav_copy = [...this.all_fiz_prav];
      this.tim = resp.data.all_pravnici;
    });
    this.unos_projekta.datum_kreiranja = moment(Date.now()).format("yyyy-MM-DD");

    //check the url params if we are on edit
    this.route_query = this.$router.history.current.params.uid;
    if (this.route_query != undefined) {
      this.is_edit = true;

      this.connectExitstingData();
      this.create_edit_button = this.$t("forms.project.title_edit");
      this.title_edit_new = this.$t("forms.project.btn_edit");
    }
    else{
      this.fetching=false;
    }
  },
  computed:{
    dateText(){
      return moment(this.unos_projekta.datum_arhiviranja).format('DD.MM.yyyy');
    },
  },
  components: {
    "form-input": formInput,
    "form-textarea": formTextarea,
    "form-drop-down": formDropDown,
    "form-autocomplete": formAutocomplete,
    "button-person-quick": buttonPersonQuick,
    "form-currency-input":formCurrencyInput,
    InvalidElementsList,
    DataLoader
  },

  mounted() {
    this.$store.state.ime_predmeta.broj_predmeta = "";
    this.$store.state.ime_predmeta.ime_stranke = "";
    this.$store.state.ime_predmeta.ime_protustranke = "";

    document.body.classList.add("new-entry");
    this.unos_projekta.broj_projekta = this.$refs.brojPredmeta.$data;
    this.unos_projekta.name = this.$refs.nazivProjekta.$data;
    this.unos_projekta.opis_projekta = this.$refs.opisProjekta.$data;
    this.unos_projekta.vezane_osobe.leg_tim = this.$refs.clanTima.$data;
    this.unos_projekta.vezane_osobe.connected = this.$refs.stranka.$data;
    this.unos_projekta.vezane_osobe.quickConnected =
      this.$refs.quickStranka.$data;

    //close anim
    $(".entry-exit").hover(
      function () {
        gsap.to($(this).find("img"), 0.3, {
          rotation: 180,
          transformOrigin: "center",
        });
      },
      function () {
        gsap.to($(this).find("img"), 0.5, {
          rotation: -180,
          transformOrigin: "center",
        });
      }
    );
  },
  updated() {
    //stavljanje broja predmeta u store
    // this.$store.state.ime_predmeta.broj_predmeta = this.prijedlog_br_predmet; provjeri zašto ne radi
    this.$store.state.ime_predmeta.broj_predmeta = this.unos_projekta.broj_projekta.value;
    // console.log(this.$store.state.ime_predmeta);
  },
  destroyed() {
    document.body.classList.remove("new-entry");
  },
};
</script>
